import React from 'react';
import 'moment/locale/fr';
import ContractDetailsHeader from './ContractDetailsHeader';
import ContractDetailStat from './ContractDetailsStat';
import { ContractDetailsGlobal } from 'api/contract';

interface ContractDetailsLayoutProps {
  contractDetails: ContractDetailsGlobal;
  children: React.ReactNode;
}

const ContractDetailsLayout: React.FC<ContractDetailsLayoutProps> = ({ contractDetails, children }) => {
  return (
    <section className="w-full overflow-hidden border bg-white rounded-2xl">
      <ContractDetailsHeader
        contractDetails={contractDetails}
      />
      <div className="p-8 space-y-8 shadow-inner">
        <ContractDetailStat contractDetails={contractDetails} />
        <div>
          {children}
        </div>
      </div>
    </section>
  );
};

export default ContractDetailsLayout;
